// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   msalConfig: {
//     authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
//     tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
//     clientId: 'abd30fc0-129d-4acd-9715-89512a574ebc',
//     redirectUri: 'http://localhost:4200/'
//   },
//   apiPath: 'http://localhost:60172/api/',
//   tokenPath: 'http://localhost:60172/api/',
//   baseURL: 'http://localhost:60172/',
//   hostingEnvironment: 'azure', // hosting env. can be iis or azure.
//    logApplicationInsights: 'Y',
//   instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
//   exitPortalURL: "https://in-ep.ey.net",
//   NHPPortal: ""

// };


export const environment = {
  production: false,
  msalConfig: {
    authURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/authorize',
    tokenURL: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c/oauth2/v2.0/token',
    clientId: 'abd30fc0-129d-4acd-9715-89512a574ebc',
    redirectUri: 'https://incrp-uat.ey.net/'
  },

  apiPath: 'https://incrp-uat.ey.net/infteApi/api/',
  tokenPath: 'https://incrp-uat.ey.net/infteApi/api/',
  baseURL: 'https://incrp-uat.ey.net/',
  hostingEnvironment: 'azure', // hosting env. can be iis or azure.
   logApplicationInsights: 'Y',
  instrumentationKey: 'b5a3470b-8c32-45b3-8250-dd5d5ffddbcb',
    exitPortalURL: "https://in-ep.ey.net",
  NHPPortal: ""

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
